"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledTypography = require("../../../StyledTypography");

var _Elements = require("../../Elements");

var _Elements2 = require("./Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable max-len */
var PrivacyPolicy = function PrivacyPolicy(_ref) {
  var siteTitle = _ref.siteTitle,
      noTitle = _ref.noTitle,
      smallHeader = _ref.smallHeader,
      setCanScroll = _ref.setCanScroll;
  var privacyBoxRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setCanScroll(true);
    return function () {
      return setCanScroll(false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _privacyBoxRef$curren, _privacyBoxRef$curren2, _privacyBoxRef$curren3, _privacyBoxRef$curren4;

    privacyBoxRef === null || privacyBoxRef === void 0 ? void 0 : (_privacyBoxRef$curren = privacyBoxRef.current) === null || _privacyBoxRef$curren === void 0 ? void 0 : (_privacyBoxRef$curren2 = _privacyBoxRef$curren.focus) === null || _privacyBoxRef$curren2 === void 0 ? void 0 : _privacyBoxRef$curren2.call(_privacyBoxRef$curren);
    privacyBoxRef === null || privacyBoxRef === void 0 ? void 0 : (_privacyBoxRef$curren3 = privacyBoxRef.current) === null || _privacyBoxRef$curren3 === void 0 ? void 0 : (_privacyBoxRef$curren4 = _privacyBoxRef$curren3.scrollTo) === null || _privacyBoxRef$curren4 === void 0 ? void 0 : _privacyBoxRef$curren4.call(_privacyBoxRef$curren3, 0, 0);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Elements2.PrivacyPolicyBox, {
    ref: privacyBoxRef,
    tabIndex: "0",
    py: "md",
    className: "portfolio__policy--container"
  }, !noTitle && (smallHeader ? /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioHeadingMedium, {
    center: true,
    portfolioForeground1: true,
    normal: true,
    mb: "md",
    large: true,
    className: "portfolio__policy--title"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.privacy_policy"
  })) : /*#__PURE__*/_react["default"].createElement(_StyledTypography.Headline, {
    center: true,
    portfolioForeground1: true,
    portfolioFontFamily: true,
    normal: true,
    mb: "md",
    className: "portfolio__policy--title"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.privacy_policy"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body1",
    values: {
      siteTitle: siteTitle
    }
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body2"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body3"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body4"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body5"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body6"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body7"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body8"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body9"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body10"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body11"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body12"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body13"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body14"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body15"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body16"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body17"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body18"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body19"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body20"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body21"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body22"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body23"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body24"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body25"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body26"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body27"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body28"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body29"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body30"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body31"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    portfolioForeground1: true,
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.privacy_policy.body32"
  })));
};

PrivacyPolicy.defaultProps = {
  siteTitle: 'site_title',
  noTitle: false,
  smallHeader: false,
  setCanScroll: function setCanScroll() {}
};
PrivacyPolicy.propTypes = {
  siteTitle: _propTypes["default"].string,
  noTitle: _propTypes["default"].bool,
  smallHeader: _propTypes["default"].bool,
  setCanScroll: _propTypes["default"].func
};
var _default = PrivacyPolicy;
exports["default"] = _default;